import { RouteComponentProps, withRouter } from "react-router-dom";
import { compose } from "recompose";

import login from "../../../hoc/persister/login";
import { ILoginProps } from "../../../hoc/persister/login/login";

import SignInForm, { IProps } from "./SignInForm.component";

type IConnectedProps = ILoginProps & RouteComponentProps;

export type IContainerProps = Omit<IProps, keyof IConnectedProps>;

export default compose<IProps, IContainerProps>(login, withRouter)(SignInForm);
